<template>
  <div style="margin:20px">
    <div v-if="!isMobile()" style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Fleet Map</span><br/>
    </div>
    <div v-if="!isMobile()"  style="font-size: 18px; font-weight: bold; position: relative;">
      <div v-if="!loading && vehicle_status_enabled && vehicle_status_dvir_enabled" style="margin-top: 20px;">
        <div class="row" style="margin: 0px; font-weight: bold; font-size: 18px;">
          <div @click="filter_by_status(null)" class="col total" :style="selected_vehicle_status==null ? 'border: 2px solid red;' : 'border: 2px solid grey;'">{{items.length}} of {{summary.vehicle_count}}</div>
          <div @click="filter_by_status('available')" :style="selected_vehicle_status=='available' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col available">Available-{{available_cnt}}</div>
          <div style="margin:8px 5px 0px 5px">|</div>
          <div v-if="washed_enabled" @click="filter_by_status('ready')" :style="selected_vehicle_status=='ready' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col ready">Ready-{{ready_cnt}}</div>
          <div @click="filter_by_status('cleaned')" :style="selected_vehicle_status=='cleaned' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col cleaned">Clean-{{clean_cnt}}</div>
          <div v-if="washed_enabled" @click="filter_by_status('washed')" :style="selected_vehicle_status=='washed' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col washed">Washed-{{washed_cnt}}</div>
          <div @click="filter_by_status('dirty')" :style="selected_vehicle_status=='dirty' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col dirty">Dirty-{{dirty_cnt}}</div>
          <div @click="filter_by_status('out')" :style="selected_vehicle_status=='out' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col out">Out-{{out_cnt}}</div>
          <div style="margin:8px 5px 0px 5px">|</div>
          <div @click="filter_by_maint_status('ready')" :style="selected_maintenance_status=='ready' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col maint-ready" >Ready-{{maint_ready_cnt}}</div>
          <div @click="filter_by_maint_status('pending_dvir')" :style="selected_maintenance_status=='pending_dvir' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col pending_dvir" >Pending-{{pending_dvir_cnt}}</div>
          <div @click="filter_by_maint_status('unsafe_dvir')" :style="selected_maintenance_status=='unsafe_dvir' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col unsafe_dvir" >Unsafe-{{unsafe_dvir_cnt}}</div>
          <div @click="filter_by_maint_status('pm')" :style="selected_maintenance_status=='pm' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col pm" >PM-{{pm_cnt}}</div>
          <div @click="filter_by_maint_status('oos')" :style="selected_maintenance_status=='oos' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col oos" >OOS-{{oos_cnt}}</div>
          <div style="margin:8px 5px 0px 5px">|</div>
          <div @click="filter_by_maint_status('garage')" :style="selected_maintenance_status=='garage' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col garage" >Garage-{{garage_cnt}}</div>
          <div class="d-flex align-items-center justify-content-center">
            &nbsp;&nbsp;<b-btn size="sm" @click="reload_data()"><span style="font-size: 18px; font-weight: bold">Reload</span></b-btn>
          </div>
        </div>
      </div>
      <div v-else-if="!loading && vehicle_status_enabled" style="margin-top: 10px;">
        <div class="row" style="margin: 10px; font-weight: bold; font-size: 24px;">
          <div @click="filter_by_status(null)" :style="selected_vehicle_status==null ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col total" style="border: 1px solid grey;">{{items.length}} of {{summary.vehicle_count}}</div>
          <div style="margin:8px 5px 0px 5px">|</div>
          <div v-if="washed_enabled" @click="filter_by_status('ready')" :style="selected_vehicle_status=='ready' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col ready">Ready-{{ready_cnt}}</div>
          <div @click="filter_by_status('cleaned')" :style="selected_vehicle_status=='cleaned' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col cleaned">Clean-{{clean_cnt}}</div>
          <div v-if="washed_enabled" @click="filter_by_status('washed')" :style="selected_vehicle_status=='washed' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col washed">Washed-{{washed_cnt}}</div>
          <div @click="filter_by_status('dirty')" :style="selected_vehicle_status=='dirty' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col dirty">Dirty-{{dirty_cnt}}</div>
          <div @click="filter_by_status('out')" :style="selected_vehicle_status=='out' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col out">Out-{{out_cnt}}</div>
          <div @click="filter_by_status('oos')" :style="selected_vehicle_status=='oos' ? 'border: 2px solid red;' : 'border: 2px solid grey;'" class="col oos">OOS-{{oos_cnt}}</div>
          <div class="d-flex align-items-center justify-content-center">
            &nbsp;&nbsp;<b-btn size="sm" @click="reload_data()"><span style="font-size: 18px; font-weight: bold">Reload</span></b-btn>
          </div>
        </div>
      </div>
      <div v-else-if="!loading" style="margin-bottom: 5px;">
        <span style="font-weight: bold; font-size: 24px;">
          <span class="total" style="padding: 5px; float: left;">showing {{items.length}} of {{summary.vehicle_count}} vehicles</span>
          <span v-if="company_options && company_options.length > 2"><b-form-select v-model="selected_company" :options="company_options" style="font-size: 20px; font-weight: bold; width:180px"/></span>
          <span style="float: right"><b-btn size="sm" @click="load_data()"><span style="font-size: 18px; font-weight: bold">Reload</span></b-btn></span>
        </span>
        <br/>
      </div>
      <br/>
    </div>
    <div v-if="!loading">
      <div ref="test" class="row" style="margin: 0px">
        <div v-if="!isMobile()" class="col" style="overflow-y:scroll; max-height: 900px; max-width: 400px; border: 1px solid grey;">
          <div v-if="user.role != 'driver' && user.role != 'customer-care'" style="margin:20px 0px 20px 0px; font-size: 22px; font-weight: bold">Sort:&nbsp;<b-form-select v-model="sort_by" :options="sort_options" style="font-size: 18px; font-weight: bold; width:120px"/>&nbsp;<b-btn size="md" @click="items = items.reverse()">&#8597;</b-btn></div>
          <hr/>
          <div class="vehicle-item" @click="toggle_div(veh, veh.name,'detailsVisible')" v-for="(veh,idx) in items" style="font-size: 16px; text-align: left; padding:5px;">
            <span style="font-size: 18px; font-weight: bold">{{veh.name}}</span>
            <span style="float:right;">
              <span v-if="(user.role != 'driver' && user.role != 'customer-care') && veh.speedMilesPerHour > 0" style="background-color: #E6FEE6; font-size: 14px; font-weight: bold; padding: 4px; margin-right: 8px; border-radius: 8px ">{{veh.speedMilesPerHour}} MPH</span>
              <span v-if="veh.speedMilesPerHour == 0">
                <svg width="20" height="20" viewBox="-5 -5 15 15"><path d="M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0"  fill="darkred" stroke="white" stroke-width="1"/></svg>
              </span>
              <span v-else-if="veh.headingDegrees > 0">
                <svg width="15" height="15" viewBox="-6 4 10 6" :style="'transform: rotate(' + veh.headingDegrees + 'deg)'"><path d="M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14"  fill="#29C68A" stroke="white" stroke-width="1"/></svg>
              </span>
            </span>
            <span v-if="veh.lastLocation" style="font-size: 14px; font-weight: bold"><br/><img style="margin: 0px 5px 3px 0px" src="/location-icon.png"/>{{veh.lastLocation}}</span>
            <span v-if="veh.driver" style="font-size: 14px">
              <br/><img style="margin: 0px 5px 5px 0px" width="15px" src="/driver-icon.png"/><b>{{veh.driver.name}} {{veh.driver.phone | prettyPhoneNumber}}</b>
            </span>
            <span v-if="veh.vehicle_status" style="font-size: 14px; font-weight: bold"><br/>Status: {{veh.vehicle_status}}</span>
            <span v-if="veh.maintenance_status && veh.maintenance_status != 'null'" style="font-size: 14px; font-weight: bold">&nbsp;|&nbsp; {{veh.maintenance_status}}</span>
            <span v-if="veh.last_returned_dt" style="font-size: 14px;font-weight: bold"><br/>Returned: {{veh.last_returned_dt}}</span>
            <span v-if="veh.next_mvmt_time" style="font-size: 14px;font-weight: bold"><br/>Next: {{veh.next_mvmt_time}}</span>
            <span v-if="veh.next_mvmt_delta" style="font-size: 14px;font-weight: bold"><br/>Departs: {{veh.next_mvmt_delta}}</span>
            <div v-if="veh.curr_mvmt_route" style="font-size: 14px; font-weight: bold">
              <img width="15px" style="margin: 0px 5px 5px 0px" src="/route-icon.png"/><b>{{veh.curr_mvmt_route}}</b>
            </div>
            <div v-if="user.role != 'driver' && user.role != 'customer-care'" style="text-align:center; border: 1px dotted black; margin-top: 10px; padding: 3px; font-size: 14px; font-weight: bold">
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/vehicle-track/' + user.tenant + '/' + veh.name }"><img style="margin: 0px 3px 2px 0px" src="/arrow-45-icon.png"/> Live Tracking</router-link>
                &nbsp;|&nbsp;
                <router-link style="font-weight: bold;" :to="{ path: '/vehicle_trip_history?vehicleId=' + veh.name }">Trips</router-link>
                &nbsp;|&nbsp;
                <router-link style="font-weight: bold;" :to="{ path: '/vehicle_route_history?vehicleId=' + veh.name }">Routes</router-link>
            </div>
            <hr/>
          </div>
        </div>
        <div class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <GmapMap id="map" ref="mapRef"
                   :zoom="zoom"
                   :center="center"
                   :options="mapStyle"
                   style="width:100%;  height: 900px;"
          >
            <GmapMarker
                v-for="(marker,idx) in markers"
                :position="marker.position"
                :title="marker.title"
                :label="marker.label"
                :draggable="false"
                :clickable="true"
                :icon="marker.icon"
                :zIndex="marker.zIndex"
                @mouseover="openInfoWindowTemplate(marker.title)"
                @mouseout="infoWindow.open=false"
            />
            <GmapInfoWindow
                :options="{
                              pixelOffset: { width: 0, height: -65 }
                            }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
            >
              <div v-html="infoWindow.template"></div>
            </GmapInfoWindow>

          </GmapMap>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  </div>
</template>
<script>
import {get_vehicle_map} from '../networking/apis'
import {gmapApi} from 'vue2-google-maps'
import {mapState} from "vuex";
import {get_tbn_vehicle_map} from "../networking/tbn_apis";

export default {
  name: 'vehicle_map',
  components: {
  },

  data() {
    return {
      vehicle_status_enabled: false,
      vehicle_status_dvir_enabled: false,
      washed_enabled: false,
      items: [],
      items_full: [],
      company_options: [],
      selected_company: '',
      summary: {},
      loading: true,
      reloading: false,
      reload_mode: 0,
      timer: null,
      sort_by: 'speedMilesPerHour',
      center: {
        lat: Number('39.855914446870386'),
        lng: Number('-96.4225664861062'),
      },
      zoom: null,
      markers: [],
      map: null,
      markers_full: [],
      filtered: [],
      markers_new: [],
      selected_vehicle_status: '',
      selected_maintenance_status: '',
      sort_options: [
        { value: 'speedMilesPerHour', text: 'Speed' },
        { value: 'name', text: 'Vehicle' },
        { value: 'last_returned_dt', text: 'Return' },
        { value: 'next_mvmt_dt', text: 'Next' },
      ],
      reload_options: [
        { value: 0, text: 'OFF' },
        { value: 30000, text: '30s' },
        { value: 60000, text: '1m' },
        { value: 300000, text: '5m' },
      ],

      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      mapStyle: {
        mapTypeControl: false,
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              { "color": "#F3F4F9" }
            ]
          },          {
            "featureType": "water",
            "stylers": [
              { "color": "#C1CDE4" }
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              { "color": "#E0EDCA" }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted () {
    const interval = setInterval(() => {
      if (this.$refs.mapRef) {
        this.$refs.mapRef.$mapObject.addListener('bounds_changed', (e) => this.filter_items())
        clearInterval(interval)
      }
    }, 1000)
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    computeMarkerZIndex(position) {
      const lat = position && position.lat != null ? Number(position.lat) : 0;
      let latKey = Math.round((90 - lat) * 1000);
      if (!Number.isFinite(latKey)) latKey = 0;
      return latKey;
    },
    async check_features() {
      this.vehicle_status_enabled = this.user.features[this.user.tenant].vehicle_status_management_enabled
      this.vehicle_status_dvir_enabled = this.user.features[this.user.tenant].vehicle_status_management_dvir_enabled
      this.selected_vehicle_status = ''
      this.selected_maintenance_status = ''
      this.sort_by = 'speedMilesPerHour'
      this.load_data()
    },
    toggle_div(item,selected_name,field) {
      item[field] = !item[field];
      this.$forceUpdate();

      const loc = this.items.filter(item => item.name == selected_name)[0]
      if (loc != null) {
        this.center = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        if (this.zoom == 15)
          this.zoom = 18
        else
          this.zoom = 15
      }
    },
    openInfoWindowTemplate(selected_name) {
      const loc = this.items.filter(item => item.name == selected_name)[0]

      if (loc != null) {
        const position = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.infoWindow.position = position
        this.infoWindow.template = loc.marker_html
        this.infoWindow.open = true
      }
    },
    async load_data() {
      this.loading = true
      try {
        this.summary = null
        this.items = null
        this.markers = [];
        let results = null;
        if (this.user.types[this.user.tenant].indexOf('CM') != -1)
          results = await get_vehicle_map(this.user.tenant, null, null, null)
        else
          results = await get_tbn_vehicle_map(this.user.tenant, null, null, null)

        const {value: { data = [] } } = results
        // const data = {'summary': {'zoom': 8}, 'results': [{
        //     "id": "212014918309245",
        //     "name": "487",
        //     "externalIds": {
        //       "samsara.serial": "G86X2RSH8Z",
        //       "samsara.vin": "2PCH3349831014757"
        //     },
        //     "gps": {
        //       "time": "2023-04-28T16:27:16Z",
        //       "latitude": "34.34555950889203",
        //       "longitude": "-117.939536784897",
        //       "headingDegrees": 15,
        //       "speedMilesPerHour": 40,
        //       "reverseGeo": {
        //         "formattedLocation": "Highway 80 Service Road, Warfield, TX, 79711"
        //       },
        //       "isEcuSpeed": false
        //     },
        //     "marker_html": "<span style=\"text-align:left;font-size: 16px\"><b>Vehicle 487</b><br/><b>Speed:</b> 0<br/><b>Checkin:</b> 04/28 09:27 AM</span>"
        //   }] }

        this.summary = data.summary
        this.items = data.results
        this.items_full = data.results
        this.zoom = this.summary.zoom
        this.washed_enabled = this.summary.washed_enabled
        this.company_options = this.summary.companies

        if (this.items && this.items.length > 0) {
          for (const loc of this.items) {
            const position = {
              lat: Number(loc.gps.latitude),
              lng: Number(loc.gps.longitude),
            };
            this.center = position;

            this.markers.push({position: position, title: loc.name, company: loc.company, vehicle_status: loc.vehicle_status, maintenance_status: loc.maintenance_status, label: {text: loc.name, className: 'marker-label'}, icon: this.arrowSymbol(loc), zIndex: this.computeMarkerZIndex(position)});
          }
        }
        this.markers_full = this.markers
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    arrowSymbol(loc) {
      return {
        path: (loc.gps.speedMilesPerHour == 0 || loc.gps.headingDegrees == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: 1.8,
        strokeColor: this.get_maint_status_color(loc),
        strokeStyle: "bold",
        fillColor: this.get_vehicle_status_color(loc),
        fillOpacity: 1,
        rotation: Number(loc.gps.headingDegrees)
      }
    },
    get_maint_status_color(loc) {
      if (loc.maintenance_status) {
        if (loc.maintenance_status === 'PENDING_DVIR')
          return 'hsla(60,100%,50%,0.8)';
        else if (loc.maintenance_status === 'UNSAFE_DVIR')
          return 'hsla(210,100%,50%,0.8)';
        else if (loc.maintenance_status === 'OOS')
          return 'rgba(255,0,0,0.8)';
        else if (loc.maintenance_status === 'READY')
          return 'rgba(255,0,0,0.8)';
      }
      return 'white';
    },
    get_vehicle_status_color(loc) {
      if (loc.vehicle_status) {
        if (loc.vehicle_status === 'READY')
          return 'hsla(204,70%,63%,0.6)';
        else if (loc.vehicle_status === 'CLEANED')
          return 'hsla(190,70%,50%,0.4)';
        else if (loc.vehicle_status === 'WASHED')
          return 'hsla(160,30%,40%,0.6)';
        else if (loc.vehicle_status === 'DIRTY')
          return 'hsla(25,28%,23%,0.6)';
        else if (loc.vehicle_status === 'OUT')
          return 'hsla(290,60%,70%,0.6)';
      }
      if (loc.gps.speedMilesPerHour == 0)
        return "darkred";
      return "#29C68A";
    },
    async reload_data() {
      try {
        this.reloading = true
        this.sort_by = 'speedMilesPerHour'

        var results = await get_vehicle_map(this.user.tenant, null, null, null)
        const {value: { data = [] } } = results
        this.summary = data.summary
        this.items = data.results
        this.items_full = data.results
        this.markers_new = []

        if (this.items && this.items.length > 0) {
          for (const loc of this.items) {
            const position = {
              lat: Number(loc.gps.latitude),
              lng: Number(loc.gps.longitude),
            };
            this.markers_new.push({position: position, title: loc.name, company: loc.company, vehicle_status: loc.vehicle_status, maintenance_status: loc.maintenance_status, label: {text: loc.name, className: 'marker-label'}, icon: this.arrowSymbol(loc), zIndex: this.computeMarkerZIndex(position)});
          }

          this.markers = this.markers_new
          this.markers_full = this.markers
          this.filter_items()
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.reloading = false
    },
    pinSymbol(color) {
      return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: 'black',
        strokeWeight: 1,
        scale: 1.5,
      }
    },
    sort_data() {
      let col = this.sort_by
      this.items = this.items.sort((a, b) => {

        if (col == 'speedMilesPerHour') {
          return a[col] < b[col] ? 1 : -1;
        }

        if (a[col] && !b[col]) {
          return -1
        } else if (!a[col] && b[col]) {
          return 1
        } else if (!a[col] && !b[col]) {
          return -1
        } else {
          if (col.includes("_dt")) {
            return new Date(a[col]) - new Date(b[col])
          } else if (a[col] < b[col]) {
            return -1
          } else if (a[col] > b[col]) {
            return 1
          }
          return 0
        }
      })
    },
    filter_items() {
      //console.log("filter_items...");
      this.items = this.items_full
      this.markers = this.markers_full

      if (this.selected_company) {
        this.items = this.items.filter(item => (item.company == this.selected_company))
        this.markers = this.markers.filter(item => item.company == this.selected_company)
      }

      if (this.selected_vehicle_status) {
        //console.log("filter by selected_vehicle_status: " + this.selected_vehicle_status);
        if (this.selected_vehicle_status == 'available') {
          this.items = this.items.filter(item => (item.vehicle_status == 'CLEANED' && item.maintenance_status == 'READY'))
          this.markers = this.markers.filter(item => (item.vehicle_status == 'CLEANED' && item.maintenance_status == 'READY'))
          this.selected_maintenance_status = null
        } else {
          this.items = this.items.filter(item => item.vehicle_status == this.selected_vehicle_status.toUpperCase())
          this.markers = this.markers.filter(item => item.vehicle_status == this.selected_vehicle_status.toUpperCase())
        }
      }

      if (this.selected_maintenance_status) {
        //console.log("filter by selected_maintenance_status: " + this.selected_maintenance_status);
        if (this.selected_maintenance_status == 'garage') {
          this.items = this.items.filter(item => (item.maintenance_status != 'READY'))
          this.markers = this.markers.filter(item => item.maintenance_status != 'READY')
        } else {
          this.items = this.items.filter(item => item.maintenance_status ==  this.selected_maintenance_status.toUpperCase())
          this.markers = this.markers.filter(item => item.maintenance_status == this.selected_maintenance_status.toUpperCase())
        }
      }

      let filtered = this.getHiddenMarkers()
      //console.log("hidden: " + filtered.length)
      if (filtered.length > 0) {
        this.items = this.items.filter(item => !filtered.includes(item.name))
      }

      this.sort_data();
    },
    filter_by_status(status) {

      if (status == null || this.selected_vehicle_status == status) {
        this.selected_vehicle_status = null
        this.items = this.items_full
        this.markers = this.markers_full
      } else {
        this.selected_vehicle_status = status
      }

      this.filter_items()

      // if (status == null || this.selected_vehicle_status == status) {
      //   this.selected_vehicle_status = null
      //   this.items = this.items_full
      //   this.markers = this.markers_full
      // } else {
      //   if (this.selected_vehicle_status == 'available') {
      //     this.items = this.items_full.filter(item => (item.vehicle_status == 'CLEANED' && item.maintenance_status == 'READY'))
      //     this.markers = this.markers_full.filter(item => (item.vehicle_status == 'CLEANED' && item.maintenance_status == 'READY'))
      //   } else {
      //     this.items = this.items_full.filter(item => item.vehicle_status == status.toUpperCase())
      //     this.markers = this.markers_full.filter(item => item.vehicle_status == status.toUpperCase())
      //   }
      // }
      //
      // let filtered = this.getHiddenMarkers()
      // if (filtered.length > 0)
      //   this.items = this.items.filter(item => !filtered.includes(item.name) )
    },
    filter_by_maint_status(status) {

      if (status == null || this.selected_maintenance_status == status) {
        this.selected_maintenance_status = null
        this.items = this.items_full
        this.markers = this.markers_full
      } else {
        this.selected_maintenance_status = status
      }

      this.filter_items()

      // if (status == null || this.selected_maintenance_status == status) {
      //   this.selected_maintenance_status = null
      //   this.items = this.items_full
      //   this.markers = this.markers_full
      // } else {
      //   this.selected_maintenance_status = status
      //   if (this.selected_maintenance_status == 'garage') {
      //     this.items = this.items_full.filter(item => (item.maintenance_status != 'READY'))
      //     this.markers = this.markers_full.filter(item => item.maintenance_status != 'READY')
      //   } else {
      //     this.items = this.items_full.filter(item => item.maintenance_status == status.toUpperCase())
      //     this.markers = this.markers_full.filter(item => item.maintenance_status == status.toUpperCase())
      //   }
      // }
      //
      // let filtered = this.getHiddenMarkers()
      // if (filtered.length > 0)
      //   this.items = this.items.filter(item => !filtered.includes(item.name) )
    },
    getHiddenMarkers(){
      let filtered = [];
      const b = this.$refs.mapRef.$mapObject.getBounds();
      this.markers.forEach(marker => {
        let markerPosition = {
          position: {
            'lat': marker.position.lat,
            'lng': marker.position.lng
          }
        };

        let m = new window.google.maps.Marker( markerPosition );
        if( !b.contains( m.getPosition() ) ){
          filtered.push(marker.title);
        }
      });
      return filtered
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    google: gmapApi,
    available_cnt() {
      if (this.washed_enabled)
        return this.items_full.filter(item => (item.vehicle_status == 'READY' && item.maintenance_status == 'READY')).length
      else
        return this.items_full.filter(item => (item.vehicle_status == 'CLEANED' && item.maintenance_status == 'READY')).length
    },
    garage_cnt() {
      return this.items_full.filter(item => item.maintenance_status != 'READY').length
    },
    clean_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'CLEANED').length
    },
    washed_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'WASHED').length
    },
    dirty_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'DIRTY').length
    },
    out_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'OUT').length
    },
    ready_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'READY').length
    },
    maint_ready_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'READY').length
    },
    pending_dvir_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'PENDING_DVIR').length
    },
    unsafe_dvir_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'UNSAFE_DVIR').length
    },
    oos_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'OOS').length
    },
    pm_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'PM').length
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    sort_by(val) {
      this.sort_data();
    },
    selected_company(val) {
      this.filter_items();
    },
    reload_mode(val) {
      clearInterval(this.timer)
      if (val > 0)
        this.timer = setInterval(this.reload_data, val);
    }
  },
}
</script>
<style scoped>

.col {
  padding-left: 2px !important;
  padding-right: 2px !important;
}

.vehicle-item:hover {
  background-color: #F6F7F9;
}

.marker-label {
  opacity: 0.8;
  bottom: 40px;
  position: relative;
  border: 1px solid black;
  background-color: #999;
  color: white !important;
  border-radius: 4px;
  padding: 2px;
}
.total { border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.washed { background-color: hsla(160,30%,40%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.ready { background-color: hsla(120,100%,75%,0.3); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}
.maint-ready { background-color: hsla(120,100%,75%,0.4); border: 1px solid grey; border-radius: 5px; padding: 2px; margin:2px}


</style>